import moment from 'moment';

type DaysLeftForTrialToOverInput = {
  freeTrialEndDt?: string | null;
};

const calculateDaysLeftForTrialToOver = ({
  freeTrialEndDt,
}: DaysLeftForTrialToOverInput): number => {
  if (!freeTrialEndDt) {
    return 0;
  }

  const endDate = moment(freeTrialEndDt);
  const today = moment().startOf('day');

  if (!endDate.isValid() || !endDate.isAfter(today)) {
    return 0;
  }

  // Compare whole calendar days rather than exact timestamps, so the result
  // doesn't depend on how many milliseconds elapsed between when nextBillDate
  // was captured and when this runs.
  const daysRemaining = endDate.startOf('day').diff(today, 'd');

  return daysRemaining;
};

export default calculateDaysLeftForTrialToOver;